import React from 'react';
import { ArrowRight, Shield, Award, Users } from 'lucide-react';
import { smoothScrollTo } from '../utils/smoothScroll';

const Hero = () => {
  const handleScrollToContact = (e) => {
    e.preventDefault();
    smoothScrollTo('#contact');
  };

  const handleScrollToProjects = (e) => {
    e.preventDefault();
    smoothScrollTo('#projects');
  };

  return (
    <section id="home" className="hero-section">
      <img
        src="https://images.unsplash.com/photo-1761877676992-0c232a7920f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzYzODIxNDEzfDA&ixlib=rb-4.1.0&q=85"
        alt="Construction background"
        className="hero-background"
      />
      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="max-w-3xl">
          <div className="inline-block mb-4 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-[#d4af37]/30">
            <span className="text-[#d4af37] font-semibold">Vaš Pouzdani Partner u Građevinarstvu</span>
          </div>
          
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Gradimo Vaše
            <span className="block text-[#d4af37]">Snove u Stvarnost</span>
          </h1>
          
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Osnovana 2024. godine, Dekor Art gradnja pruža vrhunske građevinske usluge 
            uz tim iskusnih majstora. Kvaliteta, pouzdanost i preciznost u svakom projektu.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a 
              href="#contact" 
              onClick={handleScrollToContact}
              className="btn-primary inline-flex items-center justify-center gap-2 cursor-pointer"
            >
              Započnite Projekt
              <ArrowRight className="w-5 h-5" />
            </a>
            <a 
              href="#projects" 
              onClick={handleScrollToProjects}
              className="btn-secondary inline-flex items-center justify-center gap-2 cursor-pointer"
            >
              Pogledajte Projekte
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-3 gap-6 pt-8 border-t border-white/20">
            <div className="flex items-center gap-3">
              <Shield className="w-8 h-8 text-[#d4af37]" />
              <div>
                <p className="text-white font-semibold">Osigurano</p>
                <p className="text-gray-300 text-sm">100% Garancija</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Award className="w-8 h-8 text-[#d4af37]" />
              <div>
                <p className="text-white font-semibold">Certificirano</p>
                <p className="text-gray-300 text-sm">ISO Standardi</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Users className="w-8 h-8 text-[#d4af37]" />
              <div>
                <p className="text-white font-semibold">Iskusni</p>
                <p className="text-gray-300 text-sm">50+ Stručnjaka</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;